import {useIdle} from '@mantine/hooks';
import {useEffect} from 'react';
import {useAppDispatch} from 'src/redux/hooks';
import {validateUserSessionSeamless} from 'src/redux/slices/sessionSlice';

export default function useIdleTimeout() {
  const idle = useIdle(1000 * 60 * 30); // 1000 ms = 1 s * 60 = 1 m * 30 = 30 minutes

  const dispatch = useAppDispatch();

  useEffect(() => {
    void dispatch(validateUserSessionSeamless());
  }, [idle]);

  return idle;
}
